import {withStyles, withStylesCompose} from '../withStyles';
import {Noop} from '../noop';
import styles from './styles.module.scss';

/**
 * Used in order to bundle everything together with a single component.
 * We can use this hoc in order to color each element passed, and avoid duplications.
 * */

const withNeutral50 = (Component = Noop) => withStyles(Component, styles, 'neutral50');
const withBgNeutral50Shadow = (Component = Noop) =>
  withStyles(Component, styles, 'bg-neutral50-shadow');
const withBgPurple50Wave = (Component = Noop) =>
  withStyles(Component, styles, 'bg-purple50-wave');

/**
 * Redesign 2024
 * */
const withGreen200 = (Component = Noop) => withStyles(Component, styles, 'green200');
const withGreen300 = (Component = Noop) => withStyles(Component, styles, 'green300');
const withGreen500 = (Component = Noop) => withStyles(Component, styles, 'green500');
const withGreen800 = (Component = Noop) => withStyles(Component, styles, 'green800');
const withNeutral100 = (Component = Noop) => withStyles(Component, styles, 'neutral100');
const withNeutral200 = (Component = Noop) => withStyles(Component, styles, 'neutral200');
const withNeutral500 = (Component = Noop) => withStyles(Component, styles, 'neutral500');
const withNeutral700 = (Component = Noop) => withStyles(Component, styles, 'neutral700');
const withNeutral800 = (Component = Noop) => withStyles(Component, styles, 'neutral800');
const withNeutral900 = (Component = Noop) => withStyles(Component, styles, 'neutral900');
const withPurple500 = (Component = Noop) => withStyles(Component, styles, 'purple500');
const withPurple600 = (Component = Noop) => withStyles(Component, styles, 'purple600');
const withPurple800 = (Component = Noop) => withStyles(Component, styles, 'purple800');
const withNeonVioletFlowers = (Component = Noop) =>
  withStyles(Component, styles, 'neonVioletFlowers');
const withBgBrownRose50 = (Component = Noop) => withStyles(Component, styles, 'bg-brown-rose50');
const withBgGreen50 = (Component = Noop) => withStyles(Component, styles, 'bg-green50');
const withBgGreen900 = (Component = Noop) => withStyles(Component, styles, 'bg-green900');
const withBgNeutral100 = (Component = Noop) => withStyles(Component, styles, 'bg-neutral100');
const withBgNeutral200 = (Component = Noop) => withStyles(Component, styles, 'bg-neutral200');
const withBgNeutral900 = (Component = Noop) => withStyles(Component, styles, 'bg-neutral900');
const withBgOrange50 = (Component = Noop) => withStyles(Component, styles, 'bg-orange50');
const withBgPurple50 = (Component = Noop) => withStyles(Component, styles, 'bg-purple50');
const withBgPurple100 = (Component = Noop) => withStyles(Component, styles, 'bg-purple100');
const withBgPurple900 = (Component = Noop) => withStyles(Component, styles, 'bg-purple900');
const withBgTeal800 = (Component = Noop) => withStyles(Component, styles, 'bg-teal800');
const withBgYellow50 = (Component = Noop) => withStyles(Component, styles, 'bg-yellow50');
const withBgNeutral200Rounded = (Component = Noop) =>
  withStyles(Component, styles, 'bg-neutral200-rounded');
const withBgLearnMore = (Component = Noop) => withStyles(Component, styles, 'bg-learn-more-banner');
const withBgLegalPages = (Component = Noop) =>
  withStylesCompose(Component, styles, ['neutral50', 'bg-legal-pages']);
const withBgPartnerApplication = (Component = Noop) =>
  withStyles(Component, styles, 'bg-partner-application');

export {
  withNeutral50,
  withBgNeutral50Shadow,
  withBgPurple50Wave,
  /**
   * Redesign 2024
   * */
  withGreen200,
  withGreen300,
  withGreen500,
  withGreen800,
  withNeutral100,
  withNeutral200,
  withNeutral500,
  withNeutral700,
  withNeutral800,
  withNeutral900,
  withPurple500,
  withPurple600,
  withPurple800,
  withNeonVioletFlowers,
  withBgBrownRose50,
  withBgGreen50,
  withBgGreen900,
  withBgNeutral100,
  withBgNeutral200,
  withBgNeutral900,
  withBgOrange50,
  withBgPurple50,
  withBgPurple100,
  withBgPurple900,
  withBgTeal800,
  withBgYellow50,
  withBgNeutral200Rounded,
  withBgLearnMore,
  withBgLegalPages,
  withBgPartnerApplication
};
